const decodeNewlines = (obj) => {
    if (typeof obj === 'string') {
        return obj.replace(/\\n/g, '\n');
    } else if (Array.isArray(obj)) {
        return obj.map(decodeNewlines);
    } else if (typeof obj === 'object' && obj !== null) {
        let newObj = {};
        for (let key in obj) {
            newObj[key] = decodeNewlines(obj[key]);
        }
        return newObj;
    }
    return obj;
}

export default decodeNewlines;